/* eslint-disable jsx-a11y/label-has-associated-control */
import React from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { useLabels } from 'wsm-common-data';
import Skeleton from 'wsm-skeleton';
import { setClassNames } from '@ddc/classnames-js';

const FilterItemListSkeleton = ({
	willDisplaySuggestedFilters,
	enableMobileLayoutRedesign
}) => {
	const { filterParams } = useSelector((state) => state.widgetInfo);
	const labels = useLabels();
	const count = filterParams.length;

	const filterItemListSSR = (
		<div className="facet-filters-ref">
			<div className="facet-filters d-flex align-items-baseline flex-wrap flex-nowrap-lg">
				<div className="d-none d-lg-flex align-items-baseline">
					<ul className="facet-filter-list mb-0 list-inline">
						<li className="my-1">
							<strong className="d-inline-block flex-shrink-0 mr-3" />
						</li>

						{filterParams.length > 0 &&
							filterParams.map((item) => {
								return (
									<li
										className="my-1 d-none d-lg-inline-block"
										key={item}
									>
										<button
											type="button"
											className="pill chip chip-default chip-condensed facet-filter"
										>
											{item}
											<i
												className="ddc-icon ddc-icon-remove2"
												aria-hidden="true"
											/>
										</button>
									</li>
								);
							})}

						{filterParams.length > 0 && (
							<li className="my-1 d-none d-lg-inline-block">
								<button
									type="button"
									className="facet-filter text-link d-none d-lg-inline-block"
								>
									{labels.get('CLEAR_FILTERS')}
								</button>
							</li>
						)}
					</ul>
				</div>
				<div className="w-100 d-flex d-lg-none">
					<button
						type="button"
						id="show-filters-modal-button"
						className={setClassNames([
							'btn',
							'btn-default',
							'font-weight-bold',
							'text-nowrap',
							'd-inline-block',
							enableMobileLayoutRedesign
								? 'mr-4'
								: 'ddc-font-size-large ml-auto'
						])}
					>
						<i
							className="ddc-icon ddc-icon-filter-list-controls"
							aria-hidden="true"
						/>
						{labels.get(
							enableMobileLayoutRedesign
								? 'FILTER_NO_DOTS'
								: 'FILTER_SLASH_SORT'
						)}
						{count ? (
							<div className="badge mb-0">{count}</div>
						) : null}
					</button>
					{enableMobileLayoutRedesign && (
						<button
							id="inventory-sort-button"
							type="button"
							className="btn btn-default font-weight-bold mt-0 mb-0 text-nowrap d-inline-block"
						>
							<i
								className="ddc-icon ddc-icon-up-down"
								aria-hidden="true"
							/>
							{labels.get('SORT')}
						</button>
					)}
				</div>
				<div className="ml-auto flex-shrink-0 d-none d-lg-block">
					<label htmlFor="sortBy" className="sr-only">
						Sort by
					</label>
					<select
						id="sortBy"
						className="form-control font-size-ios-zoom-override"
					>
						<option value="">Sort by</option>
						<option value="odometer asc">
							Mileage: Low to High
						</option>
					</select>
				</div>
			</div>
		</div>
	);

	return (
		<>
			{willDisplaySuggestedFilters && (
				<div>
					<Skeleton
						skeletonClasses="mb-4"
						aspectRatio="4by3"
						height="38px"
					/>
				</div>
			)}

			{filterItemListSSR}
		</>
	);
};

FilterItemListSkeleton.propTypes = {
	willDisplaySuggestedFilters: PropTypes.bool.isRequired,
	enableMobileLayoutRedesign: PropTypes.bool.isRequired
};

export default FilterItemListSkeleton;
